<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
    header-classes="d-flex align-items-center"
  >
    <template
      v-if="userData"
      #button-content
    >
      <GjIcon name="Avatar" />
    </template>

    <template v-if="isUserLoggedIn">
      <b-dropdown-header>
        <div class="d-flex align-items-center">
          <div class="profile">
            <div
              class="image"
              :style="
                userData.picture
                  ? `background-image:url(${userData.picture})`
                  : ''
              "
            />
          </div>
          <div class="user-nav">
            <p class="user-name text-main font-weight-bolder mb-0">
              {{ userData.fullName || userData.username }}
            </p>
          </div>
        </div>
      </b-dropdown-header>

      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="toProfile"
      >
        <span class="icon">
          <GjIcon name="Avatar" />
        </span>
        <span>Profile</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-if="showProject && $can('get', 'projects', 'captain')"
        :to="{
          name: 'project-settings',
          params: { projectId: $route.params.projectId },
          query: { tab: '0' },
        }"
        link-class="d-flex align-items-center"
      >
        <span class="icon">
          <GjIcon name="Settings" />
        </span>
        <span>Project Settings</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-if="showSelectProject && $can('get', 'projects', 'captain')"
        :to="{ name: 'project', params: { projectId: null } }"
        link-class="d-flex align-items-center"
      >
        <span class="icon">
          <GjIcon name="Check" />
        </span>
        <span>Select Project</span>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item
        v-if="organizationId && $can('get', 'organizations', 'captain')"
        :to="{ name: 'organization-settings', query: { tab: '0' } }"
        link-class="d-flex align-items-center"
      >
        <span class="icon">
          <GjIcon name="Settings" />
        </span>
        <span>Organization Settings</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-if="organizationId"
        link-class="d-flex align-items-center"
        @click="switchOrganization"
      >
        <span class="icon">
          <GjIcon name="RefreshAlt" />
        </span>
        <span>Switch Organization</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-if="showSelectOrganization"
        :to="{ name: 'organization', query: $route.query }"
        link-class="d-flex align-items-center"
      >
        <span class="icon">
          <GjIcon name="Check" />
        </span>
        <span>Select Organization</span>
      </b-dropdown-item>

      <b-dropdown-divider v-if="organizationId || showSelectOrganization" />

      <b-dropdown-item
        v-if="organizationId"
        link-class="d-flex align-items-center"
        @click="$router.push({ name: 'billing' })"
      >
        <span class="icon">
          <GjIcon name="Payment" />
        </span>
        <span>Billing</span>
      </b-dropdown-item>

      <b-dropdown-divider v-if="organizationId" />

      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="signOut"
      >
        <span class="icon">
          <img
            :src="require('@/assets/svg/logout.svg')"
            alt="globe"
          >
        </span>
        <span>Logout</span>
      </b-dropdown-item>
    </template>
    <template v-else>
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="toProfile"
      >
        <span class="icon">
          <GjIcon name="Avatar" />
        </span>
        <span>Login</span>
      </b-dropdown-item>
    </template>
  </b-nav-item-dropdown>
</template>

<script>
import decode from 'jwt-decode'

import { logoutUser } from '@/../GjirafaFront/script/auth/index'

import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

import { mapGetters, mapActions } from 'vuex'

import { isUserLoggedIn } from '@/auth/utils'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData') || '{}'),
      avatarText,
      portaScopeKey: 'gjirafatech_identity_admin_api',
      accessToken: localStorage.getItem('access_token'),
      isUserLoggedIn: isUserLoggedIn(),
    }
  },
  ...mapGetters('oidcStore', ['oidcIsAuthenticated']),
  hasAccess() {
    return this.oidcIsAuthenticated || this.$route.meta.isPublic
  },
  computed: {
    showProject() {
      return this.$store.state.app.projectId
    },
    organizationId() {
      return this.$store.state.app.organizationId
    },
    decodedAccessToken() {
      if (this.accessToken) {
        return decode(this.accessToken)
      }
      return null
    },
    hasPortaScope() {
      return this.decodedAccessToken
        ? this.decodedAccessToken.scope.includes(this.portaScopeKey)
        : false
    },
    showSelectProject() {
      return (
        this.organizationId
        && !this.showProject
        && this.$route.name !== 'project'
      )
    },
    showSelectOrganization() {
      return !this.organizationId && this.$route.name !== 'organization'
    },
  },
  methods: {
    ...mapActions('oidcStore', ['removeOidcUser', 'signOutOidcSilent']),
    signOut() {
      logoutUser('auth-login')
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      this.$store.commit('app/TOGGLE_LOGGING_OUT', true)
    },
    switchOrganization() {
      this.$router.push({ name: 'organization', params: { updateState: true }, query: this.$route.query })
    },
    redirect() {
      window.open(process.env.VUE_APP_PROFILE_URL, '_blank').focus()
    },
    toProfile() {
      if (this.hasPortaScope) {
        this.$router.push({ name: 'profile' })
      } else {
        this.redirect()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dropdown-user {
  .profile {
    width: 50px;
    height: 50px;
    padding-top: 10px;
    padding-right: 16px;
    padding-bottom: 10px;
    padding-left: 3px;
    .image {
      width: 100%;
      height: 100%;
      border-radius: 50px;
      background-color: var(--gray-dark);
      background-size: cover;
    }
  }
  ::v-deep {
    .dropdown-menu {
      max-height: auto !important;
    }
  }
}
</style>
